import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import InventoryIcon from "@mui/icons-material/Inventory";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import WarehouseOutlinedIcon from "@mui/icons-material/WarehouseOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import { admin } from "data/authData";

export const isMboLfsQtyViewer = (user) => {
	const role = user?.role || {};
	if (role[admin] || role.EDITOR || role.PUBLISHER) return false;
	return Boolean(role.VIEWER);
};

export const SOH_COLUMNS = [
	{ key: "customer_name", label: "Customer Name", required: true },
	{ key: "store_name", label: "Store Name", required: true },
	{ key: "date", label: "Date", required: true },
	{ key: "ean_code", label: "EAN Code", required: true },
	{ key: "qty", label: "Qty", required: true },
];

export const GIT_COLUMNS = [
	{ key: "customer_name", label: "Customer Name", required: true },
	{ key: "store_name", label: "Store Name", required: true },
	{ key: "date", label: "Date", required: true },
	{ key: "ean_code", label: "EAN Code", required: true },
	{ key: "qty", label: "Qty", required: true },
	{ key: "invoice_no", label: "Invoice No", required: true },
];

export const CN_COLUMNS = [
	...GIT_COLUMNS,
	{ key: "cn_amount", label: "CN Amount", required: true },
];

export const UPLOAD_TYPES = [
	{
		key: "cus_soh",
		name: "CUS-SOH",
		group: "Stock on Hand",
		description: "Customer stock on hand by EAN",
		schema: "soh",
		columns: SOH_COLUMNS,
		icon: <WarehouseOutlinedIcon />,
		sample: ["SHIVERA TRADING CO", "MUMBAI", "2026-03-01", "8901234567890", 120],
	},
	{
		key: "dis_git",
		name: "DIS-GIT",
		group: "RTPL-DIS",
		description: "RTPL-DIS dispatch goods in transit",
		schema: "git",
		columns: GIT_COLUMNS,
		icon: <LocalShippingOutlinedIcon />,
		sample: ["SHIVERA TRADING CO", "MUMBAI", "2026-03-01", "8901234567890", 20, "DIS-1001"],
	},
	{
		key: "rtv_git",
		name: "RTV-GIT",
		group: "RTPL-DIS",
		description: "RTPL-DIS RTV goods in transit",
		schema: "git",
		columns: GIT_COLUMNS,
		icon: <LocalShippingOutlinedIcon />,
		sample: ["SHIVERA TRADING CO", "MUMBAI", "2026-03-01", "8901234567890", 5, "RTV-2001"],
	},
	{
		key: "dis_git_2",
		name: "DIS-GIT-2",
		group: "DIS-RET",
		description: "DIS-RET dispatch goods in transit",
		schema: "git",
		columns: GIT_COLUMNS,
		icon: <LocalShippingOutlinedIcon />,
		sample: ["SHIVERA TRADING CO", "DELHI", "2026-03-02", "8901234567123", 8, "DIS-1002"],
	},
	{
		key: "rtv_git_2",
		name: "RTV-GIT-2",
		group: "DIS-RET",
		description: "DIS-RET RTV goods in transit",
		schema: "git",
		columns: GIT_COLUMNS,
		icon: <LocalShippingOutlinedIcon />,
		sample: ["SHIVERA TRADING CO", "DELHI", "2026-03-02", "8901234567123", 3, "RTV-2002"],
	},
	{
		key: "shortage_cn",
		name: "SHORTAGE-CN",
		group: "Settlement",
		description: "Shortage credit notes",
		schema: "cn",
		columns: CN_COLUMNS,
		icon: <ReceiptLongOutlinedIcon />,
		sample: ["SHOPPERS STOP LTD", "BANGALORE", "2026-03-03", "8901234567456", 10, "CN-S-301", 2500],
	},
	{
		key: "dispute_cn",
		name: "DISPUTE-CN",
		group: "Settlement",
		description: "Dispute credit notes",
		schema: "cn",
		columns: CN_COLUMNS,
		icon: <ReceiptLongOutlinedIcon />,
		sample: ["SHOPPERS STOP LTD", "BANGALORE", "2026-03-03", "8901234567456", 4, "CN-D-401", 980],
	},
];

export const mboLfsQtyRecoDashboardServices = {
	mbo_lfs_qty_reco: {
		name: "MBO LFS Qty Reco",
		key: "mbo_lfs_qty_reco",
		display: true,
		icon: <InventoryIcon />,
		types: {
			summary: {
				name: "Summary",
				description:
					"Customer-level qty reco: DIS, RTV, net SOH, GIT, shortage/dispute CN and final variance.",
				key: "summary",
				display: true,
				icon: <SummarizeOutlinedIcon />,
			},
			ror_summary: {
				name: "ROR Summary",
				description: "Customer-level ROR summary for the selected month.",
				key: "ror_summary",
				display: true,
				icon: <AssessmentOutlinedIcon />,
			},
			detail: {
				name: "Detail",
				description:
					"Bill and barcode-level quantity differences for investigation and correction.",
				key: "detail",
				display: true,
				icon: <ListAltOutlinedIcon />,
			},
			upload: {
				name: "Upload",
				description:
					"Upload CUS-SOH, DIS-GIT, RTV-GIT, shortage CN and dispute CN files separately.",
				key: "upload",
				display: true,
				icon: <UploadFileOutlinedIcon />,
			},
		},
	},
};
